// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.simplebar-content:before,
.simplebar-content:after {
  content: ' ';
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  left: 0;
  right: 0;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: '';
  background: black;
  border-radius: 7px;
  left: 2px;
  right: 2px;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/simplebar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,UAAU;EACV,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY,EAAE,mGAAmG;EACjH,WAAW;EACX,eAAe,EAAE,kDAAkD;EACnE,gBAAgB,EAAE,0CAA0C;EAC5D,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,0DAA0D;EAC1D,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B","sourcesContent":["[data-simplebar] {\r\n  position: relative;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.simplebar-wrapper {\r\n  overflow: hidden;\r\n  width: inherit;\r\n  height: inherit;\r\n  max-width: inherit;\r\n  max-height: inherit;\r\n}\r\n\r\n.simplebar-mask {\r\n  direction: inherit;\r\n  position: absolute;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  z-index: 0;\r\n}\r\n\r\n.simplebar-offset {\r\n  direction: inherit !important;\r\n  box-sizing: inherit !important;\r\n  resize: none !important;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.simplebar-content-wrapper {\r\n  direction: inherit;\r\n  box-sizing: border-box !important;\r\n  position: relative;\r\n  display: block;\r\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\r\n  width: auto;\r\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\r\n  max-height: 100%; /* Needed for vertical scroll to trigger */\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n}\r\n\r\n.simplebar-content-wrapper::-webkit-scrollbar,\r\n.simplebar-hide-scrollbar::-webkit-scrollbar {\r\n  display: none;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.simplebar-content:before,\r\n.simplebar-content:after {\r\n  content: ' ';\r\n  display: table;\r\n}\r\n\r\n.simplebar-placeholder {\r\n  max-height: 100%;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n.simplebar-height-auto-observer-wrapper {\r\n  box-sizing: inherit !important;\r\n  height: 100%;\r\n  width: 100%;\r\n  max-width: 1px;\r\n  position: relative;\r\n  float: left;\r\n  max-height: 1px;\r\n  overflow: hidden;\r\n  z-index: -1;\r\n  padding: 0;\r\n  margin: 0;\r\n  pointer-events: none;\r\n  flex-grow: inherit;\r\n  flex-shrink: 0;\r\n  flex-basis: 0;\r\n}\r\n\r\n.simplebar-height-auto-observer {\r\n  box-sizing: inherit;\r\n  display: block;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 1000%;\r\n  width: 1000%;\r\n  min-height: 1px;\r\n  min-width: 1px;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  z-index: -1;\r\n}\r\n\r\n.simplebar-track {\r\n  z-index: 1;\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  pointer-events: none;\r\n  overflow: hidden;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-content {\r\n  pointer-events: none;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-track {\r\n  pointer-events: all;\r\n}\r\n\r\n.simplebar-scrollbar {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  min-height: 10px;\r\n}\r\n\r\n.simplebar-scrollbar:before {\r\n  position: absolute;\r\n  content: '';\r\n  background: black;\r\n  border-radius: 7px;\r\n  left: 2px;\r\n  right: 2px;\r\n  opacity: 0;\r\n  transition: opacity 0.2s linear;\r\n}\r\n\r\n.simplebar-scrollbar.simplebar-visible:before {\r\n  /* When hovered, remove all transitions from drag handle */\r\n  opacity: 0.5;\r\n  transition: opacity 0s linear;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical {\r\n  top: 0;\r\n  width: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\r\n  top: 2px;\r\n  bottom: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal {\r\n  left: 0;\r\n  height: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\r\n  height: 100%;\r\n  left: 2px;\r\n  right: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\r\n  right: auto;\r\n  left: 0;\r\n  top: 2px;\r\n  height: 7px;\r\n  min-height: 0;\r\n  min-width: 10px;\r\n  width: auto;\r\n}\r\n\r\n/* Rtl support */\r\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.hs-dummy-scrollbar-size {\r\n  direction: rtl;\r\n  position: fixed;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  height: 500px;\r\n  width: 500px;\r\n  overflow-y: hidden;\r\n  overflow-x: scroll;\r\n}\r\n\r\n.simplebar-hide-scrollbar {\r\n  position: fixed;\r\n  left: 0;\r\n  visibility: hidden;\r\n  overflow-y: scroll;\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
